import i18n from '@/plugins/i18n';

export const forms = [
    {
        type: 'text',
        name: 'name',
        title: 'Müşteri Adı',
        rules: {required: true},
        modal: ['person_name'],
        data: ['person_name'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'surname',
        title: 'Müşteri Soyadı',
        rules: {required: true},
        modal: ['person_surname'],
        data: ['person_surname'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'status',
        title: i18n.t('dealer.servicesForm.status'),
        rules: {required: true},
        modal: ['status'],
        data: ['status'],
        default:{ label: i18n.t('dealer.servicesForm.open'), value: 'open' },
        options: {
            type: 'locale',
            data: [
                { label: i18n.t('dealer.servicesForm.open'), value: 'open' },
                { label: i18n.t('dealer.servicesForm.close'), value: 'close' },
            ],
            label: 'label',
            track: 'value'
        },
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'result',
        title: 'Servis Sonucu',
        rules: {required: true},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'comment',
        title: 'Teknisyen Yorumu',
        rules: {required: false},
        modal: ['detection'],
        data: ['detection'],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/movementForm.js